import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ErrorModal = ({
  isOpen,
  toggle,
  message,
  entityName = 'Item',
  associations = {}
}) => {
  const sectionStyle = {
    marginBottom: '1rem'
  };

  const errorHeaderStyle = {
    backgroundColor: '#f8d7da',
    color: '#721c24',
    borderBottom: '1px solid #f5c6cb',
    fontSize: '1.1rem',
    padding: '0.75rem 1rem'
  };

  const hasAssociations = Object.values(associations).some(
    (items) => Array.isArray(items) && items?.length > 0
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="modal-sm modal-dialog-centered"
    >
      <ModalHeader toggle={toggle} style={errorHeaderStyle}>
        <i className="fas fa-exclamation-circle mr-2" />
        {message}
      </ModalHeader>
      <ModalBody>
        <p style={{ fontWeight: '500', color: '#721c24' }}>
          {`O ${entityName?.toLowerCase()} não pode ser excluído porque está associado aos seguintes itens:`}
        </p>

        {Object.entries(associations).map(([key, items]) =>
          Array.isArray(items) && items?.length > 0 ? (
            <div key={key} style={sectionStyle}>
              <strong style={{ color: '#721c24' }}>
                {`${
                  key.charAt(0).toUpperCase() + key.slice(1)
                } associados(as):`}
              </strong>
              <ul
                style={{
                  marginTop: '8px',
                  paddingLeft: '20px',
                  color: '#495057'
                }}
              >
                {items.map((item, index) => (
                  <li key={index} style={{ marginBottom: '4px' }}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ) : null
        )}

        {!hasAssociations && (
          <p style={{ color: '#721c24' }}>
            Detalhes específicos não disponíveis. Verifique as associações
            manualmente.
          </p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ErrorModal;
